module.exports = __webpack_public_path__ + "static/media/avatar.bcb163e2.png";